export default __webpack_public_path__ + "static/media/loupe.f8d0b959.svg";